import { render, staticRenderFns } from "./StoreCenterPage.vue?vue&type=template&id=8b188fa6&scoped=true"
import script from "./StoreCenterPage.vue?vue&type=script&lang=js"
export * from "./StoreCenterPage.vue?vue&type=script&lang=js"
import style0 from "./StoreCenterPage.vue?vue&type=style&index=0&id=8b188fa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b188fa6",
  null
  
)

export default component.exports